import { useSpreedlyHosted } from '../spreedly-payment-hosted.hooks';
import SpreedlyPaymentHostedWrapper from '../spreedly-payment-hosted-wrapper.component';
import SpredlyPaymentHostedForm from '../spreedly-payment-hosted-form/spreedly-payment-hosted-form.component';

const SpreedlyPaymentPageHosted = () => {
  const {
    initOrderResponse,
    loading,
    spreedlyScriptLoading,
    refetchInitOrder,
  } = useSpreedlyHosted();

  return (
    <SpreedlyPaymentHostedWrapper isLoading={spreedlyScriptLoading}>
      {!!initOrderResponse && (
        <SpredlyPaymentHostedForm
          initOrderResponse={initOrderResponse}
          refetchInitOrder={refetchInitOrder}
          loading={loading}
        />
      )}
    </SpreedlyPaymentHostedWrapper>
  );
};

export default SpreedlyPaymentPageHosted;
